import { render } from "./OrderSummaryComponent.vue?vue&type=template&id=6d2b24b4&scoped=true"
import script from "./OrderSummaryComponent.vue?vue&type=script&lang=js"
export * from "./OrderSummaryComponent.vue?vue&type=script&lang=js"

import "./OrderSummaryComponent.vue?vue&type=style&index=0&id=6d2b24b4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2b24b4"]])

export default __exports__